import React, { useEffect, useState } from "react";
import {
  Checkbox,
  makeStyles,
  CircularProgress,
  ListItemText,
  TextField,
  Box,
} from "@material-ui/core";
import config from "../../config/aws-exports";
import { Constants } from "../../config/constants";
import { authData } from "../../redux/auth/authSlice";
import { API } from "aws-amplify";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Add from "./AddAnnouncement.module.scss";
import { Autocomplete } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
  },
  formControl: {
    border: "1px solid #6a6a6a",
    height: "fit-content",
    width: "100%",
    borderRadius: "5px",
    fontSize: "14px",
    fontFamily: "nunito",
    padding: "5px",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  program: {
    fontSize: "16px",
    color: "black",
    fontWeight: "500",
    paddingLeft: "5px",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

const AddInstructor = (props) => {
  const { handleClose, getFaculty, facultyData, Instructors, getUsersDetails } =
    props;
  const classes = useStyles();
  const [personName, setPersonName] = useState([]);
  const [courseErr, setCourseErr] = useState("");
  const [spin, setSpin] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const userDetails = useSelector(authData);

  useEffect(() => {
    // Initialize personName with faculty emails
    const initialEmails =
      facultyData?.filter((item) => item !== null).map((item) => item.email) ||
      [];
    setPersonName(initialEmails);

    // Filter instructors not already in the batch

    // const filteredInstructors = Instructors?.filter(
    //   (instructor) =>
    //     !instructor?.col15?.some(
    //       (role) => role.batchid === userDetails?.curprgcou?.bpid
    //     )
    // );

    const filteredInstructors = Instructors;
    console.log("filteredInstructors", filteredInstructors);

    setFiltered(filteredInstructors || []);
  }, [facultyData, Instructors, userDetails]);

  const onsubmit = () => {
    let formIsValid = true;
    setCourseErr("");

    if (personName.length === 0) {
      formIsValid = false;
      setCourseErr("*Please select instructors from list");
      return;
    }

    if (formIsValid) {
      addInstructor();
    }
  };

  const handleChange = (event, newValue) => {
    // newValue is an array of selected instructor objects
    const selectedEmails = newValue.map((instructor) => instructor.col3);
    setPersonName(selectedEmails);
  };

  async function addInstructor() {
    setSpin(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        batchid: userDetails.curprgcou.bpid,
        emailid: personName,
        batch: userDetails.curprgcou.bname,
        bpid: userDetails.curprgcou.bpid,
        atype: 1,
        role: "Instructor",
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.ADD_USER_TO_BATCH,
        bodyParam
      );

      handleClose();
      if (response.statusCode === 200) {
        swal({
          title: "Success",
          text: "Instructor added Successfully to the Batch",
          icon: "success",
          dangerMode: false,
        }).then(() => {
          handleClose();
          setSpin(false);
          getFaculty();
          getUsersDetails();
        });
      } else if (response.statusCode === 0) {
        swal({
          title: "Oooops!",
          text: "Instructor already exist in the batch!",
          icon: "warning",
          dangerMode: true,
        }).then(() => {
          setSpin(false);
        });
      } else if (response.statusCode === 300) {
        swal({
          title: "Success",
          text: "Instructor successfully removed from the batch!",
          icon: "success",
          dangerMode: false,
        }).then(() => {
          handleClose();
          setSpin(false);
          getFaculty();
          getUsersDetails();
        });
      } else if (response.statusCode === 5) {
        swal({
          title: "Oooops!",
          text: "This user is not an Instructor!",
          icon: "warning",
          dangerMode: true,
        }).then(() => {
          setSpin(false);
        });
      } else {
        swal({
          title: "Oooops!",
          text: "Instructor does not exist!",
          icon: "warning",
          dangerMode: true,
        }).then(() => {
          setSpin(false);
        });
      }
    } catch (error) {
      swal({
        title: "Oooops!",
        text: "Something went wrong!",
        icon: "warning",
        dangerMode: true,
      }).then(() => {
        setSpin(false);
      });
    }
  }

  return (
    <div>
      {spin ? (
        <div className={classes.root}>
          <CircularProgress style={{ color: config.main_color_1 }} />
        </div>
      ) : (
        <div className={Add.mainpopup}>
          <h3 className={Add.header}>Add Instructor</h3>
          <div className={Add.multiselect}>
            <div
              style={{
                color: "#cc0000",
                marginBottom: "12px",
                marginTop: "-10px",
                textAlign: "start",
                marginLeft: "20%",
              }}
            >
              {courseErr}
            </div>
            <Autocomplete
              multiple
              options={filtered}
              value={filtered.filter((option) =>
                personName.includes(option.col3)
              )}
              onChange={handleChange}
              getOptionLabel={(option) => `${option.col3} (${option.col1})`}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    checked={selected}
                  />
                  <ListItemText primary={`${option.col3} (${option.col1})`} />
                </li>
              )}
              style={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Select Instructors"
                  placeholder="Search..."
                  InputLabelProps={{ style: { fontSize: 15 } }}
                />
              )}
              filterOptions={(options, { inputValue }) =>
                options.filter(
                  (option) =>
                    option.col3
                      .toLowerCase()
                      .includes(inputValue.toLowerCase()) ||
                    option.col1.toLowerCase().includes(inputValue.toLowerCase())
                )
              }
              sx={{
                ".MuiAutocomplete-tag": {
                  marginRight: "8px",
                  fontSize: "15px",
                },
                ".MuiFormControl-fullWidth": {
                  height: "200px",
                  overflow: "auto",
                },
                ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
                  fontSize: "12px",
                },
                ".css-6od3lo-MuiChip-label": {
                  overflow: "unset",
                },
              }}
            />
          </div>

          <h3
            style={{
              textAlign: "left",
              fontSize: "16px",
              marginTop: "15px",
              marginBottom: "10px",
            }}
          >
            Selected Instructors
          </h3>
          <div
            style={{
              textAlign: "left",
              fontSize: "15px",
              marginLeft: "15px",
              height: "150px",
              overflow: "auto",
            }}
          >
            <ol>
              {personName?.map((email) => (
                <li key={email}>{email}</li>
              ))}
            </ol>
          </div>

          <div className={Add.buttonholder}>
            <button className={Add.cancel} onClick={handleClose}>
              Cancel
            </button>
            <button className={Add.submit} onClick={onsubmit}>
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddInstructor;
